import { Web } from "@/helpers/web";

const device = {
    mounted(el, binding, vnode) {
        const deviceType = binding.arg;
        const isMobile = Web.IsMobileTablet();
        if ((deviceType == "pc" && isMobile) || (deviceType == "mobile" && !isMobile)) {
            //const comment = document.createComment('device-' + deviceType);
            //el.replaceWith(comment);
            el.remove();
        }
    },
};
export default device;